const styles = theme => ({
    h1: {
        fontFamily: 'Montserrat',
        color: 'black',
        fontSize: '60px',
        margin: '0',
        fontWeight: '700',
        marginBottom: '30px',
        letterSpacing: '0.01em',
        lineHeight: '75px',
        textAlign: 'center',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            fontSize: '2rem',
            lineHeight: '40px'
        }
    },
    h2: {
        fontFamily: 'Aktiv Grotesk',
        fontWeight: '400',
        fontSize: '1rem',
        margin: '0',
        lineHeight: '22.4px',
        letterSpacing: '0.01em',
        color: 'black',
        textAlign: 'center',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            fontSize: '1rem'
        }
    }
})

export default styles